import React from 'react';

import { Icon } from 'components';

import { IPropTypes as IconProps } from 'e100-react-components/lib/components/Icon/index';

export const FavouriteStationIcon = (props: FavouriteStationIconProps) => {
  return (
    <Icon
      {...props}
      kind={props.color === 'primary' ? 'bookmark' : 'bookmarkBorder'}
    />
  );
};

export interface FavouriteStationIconProps extends Omit<IconProps, 'kind'> {}

